export default () => ({
  dkLegalContact: {
    count: 0,
    results: [],
  },

  statistics: {},
})
